import api from '@/utils/api';
import Toolbar from '@/components/toolbar';
import LoadingComponent from '@/components/loading-component';
import ActionIcons from '@/components/service-log/action-icons/action-icons.vue';
import SubmissionHistory from '@/components/service-log/history/submission-history-dialog/submission-history-dialog.vue';
import utilityFunctions from '@/utils/functions';
import BottomNav from '@/components/bottom-nav';
import * as Constants from '@/constants';
import SelectStudents from '../select-student-dialog/select-student-dialog.vue';

export default {
  components: {
    Toolbar,
    SelectStudents,
    LoadingComponent,
    ActionIcons,
    SubmissionHistory,
    BottomNav
  },
  name: 'DashboardView',
  data() {
    return {
      provider: '',
      submissionArray: null,
      appReady: false,
      showLoading: false,
      confirmationDialog: false
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    }
  },
  methods: {
    goToSearch() {
      this.$router.push('/search');
    },
    loadDashboard() {
      this.showLoading = true;
      api.get(Constants.NSL_DASHBOARD_LISTING_URL(5))
        .then((res) => {
          this.appReady = true;
          this.showLoading = false;
          this.submissionArray = res.data.data;
        })
        .catch((error) => {
          this.errorMsg = error.message;
          this.showLoading = false;
        });
    },
    serviceLogDeleted() {
      this.loadDashboard();
    },
    showConfirmation(log) {
      this.confirmationDialog = log;
    },
    historyDialogClosed() {
      this.confirmationDialog = false;
      this.loadDashboard();
    }
  },
  created() {
    utilityFunctions.clearSubmissionArray();
    this.showLoading = true;
    this.loadDashboard();
  }
};



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js